import React from "react";
import Icon from "../../../icons";
import OrgSkillSet from "../FormComponent/orgSkillSet";

const SkillsetsSection = ({ skillSetData, orgSkillSets, handleUpdateTagForOrg }) => (
  <div className="form-row mb__18">
    <label className="gridEven col-md-3">
      <span>Skillsets</span>
      <span
        className="quickTooltip large quickTooltip-bottom info"
        data-quicktooltip="Skillsets define the business services which you provide within ClaimColony. For example, if you're into Event Management, create or select skillset(s) such as Catering, Florist, Scheduler, etc…"
      >
        <Icon name="info" className="icon ml greyInfoIcon" />
      </span>
    </label>
    <span className="gridOdd col-md-9">
      <OrgSkillSet
        name="org_tag"
        inputTags={skillSetData}
        suggestions={orgSkillSets}
        maxskillSet="75"
        updateTagForOrg={handleUpdateTagForOrg}
      />
    </span>
  </div>
);

export default SkillsetsSection;
